export default function XPath_Syntax() {
  return (
    <div>
      <h1>XPath_Syntax</h1>
      <p>This is the XPath_Syntax component.</p>
    </div>
  );
}